/**
 * @Relay no-runtime
 */
/**
 * @graphql cc
 */
import graphql from 'graphql-tag';
import { useMemo } from 'react';
import {
	// eslint-disable-next-line graphql-relay-compat/no-import-apollo-functions -- Read http://go/cfe-no-import-apollo-functions
	useQuery,
	// eslint-disable-next-line graphql-relay-compat/no-import-apollo-functions -- Read http://go/cfe-no-import-apollo-functions
	useMutation,
} from 'react-apollo';

import { usePageContentId } from '@confluence/page-context';

import { normalizeContentLabelsData } from '../normalizers/normalizeContentLabelsData.ts';

import type {
	useContentLabelsDetailsPanelContentLabelDeleteMutation as useContentLabelsDetailsPanelContentLabelDeleteMutation$data,
	useContentLabelsDetailsPanelContentLabelDeleteMutationVariables as useContentLabelsDetailsPanelContentLabelDeleteMutation$variables,
} from './__types__/useContentLabelsDetailsPanelContentLabelDeleteMutation.ts';
import type {
	useContentLabelsDetailsPanelContentLabelsQuery as useContentLabelsDetailsPanelContentLabelsQuery$data,
	useContentLabelsDetailsPanelContentLabelsQueryVariables as useContentLabelsDetailsPanelContentLabelsQuery$variables,
} from './__types__/useContentLabelsDetailsPanelContentLabelsQuery.ts';
const useContentLabelsDetailsPanelContentLabelsQuery = graphql`
	query useContentLabelsDetailsPanelContentLabelsQuery($contentId: ID!) {
		singleContent(id: $contentId) {
			id
			labels(orderBy: { sortField: LABELLING_CREATIONDATE, direction: ASCENDING }) {
				count
				nodes {
					id
					label
					name
					prefix
				}
			}
		}
		content(id: $contentId, status: ["archived", "current", "draft"]) {
			nodes {
				id
				type
				operations {
					operation
					targetType
				}
			}
		}
	}
`;
const useContentLabelsDetailsPanelContentLabelDeleteMutation = graphql`
	mutation useContentLabelsDetailsPanelContentLabelDeleteMutation(
		$contentId: ID!
		$label: String!
	) {
		deleteLabel(input: { contentId: $contentId, label: $label }) {
			contentId
		}
	}
`;
export const useContentLabels = () => {
	const [contentId = ''] = usePageContentId();

	const { data, loading, error, refetch } = useQuery<
		useContentLabelsDetailsPanelContentLabelsQuery$data,
		useContentLabelsDetailsPanelContentLabelsQuery$variables
	>(useContentLabelsDetailsPanelContentLabelsQuery, {
		variables: {
			contentId,
		},
		skip: !contentId,
	});
	const [handleDeleteLabelClick] = useMutation<
		useContentLabelsDetailsPanelContentLabelDeleteMutation$data,
		useContentLabelsDetailsPanelContentLabelDeleteMutation$variables
	>(useContentLabelsDetailsPanelContentLabelDeleteMutation);

	const normalizedData = useMemo(() => normalizeContentLabelsData(data), [data]);

	return {
		data: normalizedData,
		handleDeleteLabelClick,
		loading,
		error,
		refetch,
	};
};
